package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCustomerRequest(
    val GivenName: String,
    val FamilyName: String,
    val DisplayName: String,
    val PrimaryEmailAddr: PrimaryEmailAddr?,
    val PrimaryPhone: PrimaryPhone? = null,
    val BillAddr: CustomerBillAddr? = null,
    val CompanyName: String? = null,
)